/** Default package name for any kind of definition files */
export const DEFS_PACKAGE_NAME_DEFAULT = 'types';
